export const handOverOptions = [
  "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown", 
  "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
];

export const takenOverOptions = [
  "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson", 
  "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
];

export const reportRows = [
  "Lab Reports", "X-Ray", "Echo/PFT/TMT", "ECG", "USG", "MRI", 
  "Case Sheet/Operative Notes", "Others"
];
